import React from "react";
import ReactDOM from "react-dom/client";
import "./App.css";
import WeddingWebsite from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <WeddingWebsite />
  </React.StrictMode>
);
